<template>
    <div class="row">
        <div>
            <a class="is-aligned-right" style="margin: 30px 0 0 10px; cursor: pointer;" :href="url(`admin/budgets-csv?from=` + from.format('YYYY-MM-DD'))">Download CSV</a>
            <h1 class="editable-month-select">Budgets
                <span v-if="isSelectingDate">
                    <select :value="from" @input="dateSelected" style="font-size: 0.8em;">
                        <option v-for="d in dates" :value="d.name">{{ d.display_name }}</option>
                    </select>
                </span>
                <span v-else @click="isSelectingDate = true" style="border-bottom: 1px dashed black; cursor: pointer;">
                {{ from.format('MMMM YYYY') }}
                </span>
            </h1>
        </div>

        <div>
            <span class="glyphicon glyphicon-refresh is-aligned-right" title="Reload" style="margin: 30px 0 0 10px; cursor: pointer;" @click="reloadData" ></span>
            <span v-if="show_budget_check" class="glyphicon glyphicon-check is-aligned-right" title="Check Budgets" style="margin: 30px 0 0 10px; cursor: pointer;" :style="{color: check_budgets ? 'red' : 'inherit'}" @click="check_budgets = !check_budgets"></span>

            <span class="is-aligned-right" style="margin-left: 10px;">Sort by:
                <select v-model="sort" class="form-control">
                    <option value="name">Name</option>
                    <option value="agency">Agency</option>
                </select>
            </span>

            <span class="is-aligned-right" style="margin-left: 10px;">Agency:
                <select v-model="agency" class="form-control">
                    <option v-for="a in agencies" :value="a.value">{{ a.name }}</option>
                </select>
            </span>
            <span class="is-aligned-right" style="margin-left: 10px;">Type:
                <select v-model="type" class="form-control">
                    <option value="">...</option>
                    <option value="direct">Direct</option>
                    <option value="agency">Agency</option>
                </select>
            </span>
            <span class="is-aligned-right" style="margin-left: 10px;">Trial:
                <select v-model="trial" class="form-control">
                    <option v-for="(key, value) in {'': '...', 'only_trial': 'Trials Only', 'no_trials': 'No Trials'}" :value="value">{{ key }}</option>
                </select>
            </span>

            <salesmen-filter :is-part-of-form="true" :is-inline="true" style="float: right; margin-left: 10px; width: 160px"
                             :salesmen-list="salesmanList" v-model="selectedSalesman"></salesmen-filter>
            <span class="is-aligned-right" style="margin-left: 10px; width: 160px">
                Account Manager
                <select class="form-control" name="accountManager" v-model="selectedAccMrg">
                    <option value="" >...</option>
                    <option v-for="person in accMrgList" :value="person.id">{{person.name}}</option>
                </select>
            </span>
            <span class="is-aligned-right" style="margin-left: 10px;">Search:
                <input type="text" v-model="search" class="form-control">
            </span>

        </div>

        <budgets-drilldown :month="from" :sort="sort" :search="search" :agency="agency" :type="type" :salesman="selectedSalesman" :account-manager="selectedAccMrg" :check_budgets="check_budgets" :version="version" :trial="trial"
                           :accountManagerList="accMrgList"
        ></budgets-drilldown>
    </div>
</template>
<script>
    export default {
        props: [
            'salesmanList',
            'accMrgList'
        ],
        data() {
            let dates = _.map(_.range(0, 16), (diff) => {
                let val = moment().startOf('month').add(1, 'months').subtract(diff, 'months');
                return {
                    'name': val,
                    'display_name': val.format('MMMM YYYY'),
                }
            });

            return {
                'from': moment().startOf('month'),
                'isSelectingDate': false,
                'dates' : dates,
                'sort': 'name',
                'trial': '',
                'type': '',
                'agency': null,
                'agencies': [],
                'search': '',
                'version': 1,
                'check_budgets': false,
                'show_budget_check': true,
                selectedSalesman: null,
                selectedAccMrg: '',
            }
        },
        methods: {
            dateSelected(event) {
                this.$data.from = moment(event.target.value);
                this.$data.isSelectingDate = false;

                this.$data.show_budget_check = moment(event.target.value).startOf('month').calendar() === moment().startOf('month').calendar();
                if (!this.$data.show_budget_check) {
                    this.check_budgets = false;
                }
            },
            reloadData() {
                this.$data.version ++;
            }
        },
        mounted() {
            axios.get(url(`admin/agency/list`)).then((response) => {
                this.$data.agencies = [ { name: '...', value: null}, ... _.map(response.data, x => { return { name: x.name, value: x.name }; }) ];
            });
        }
    }
</script>
